import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

export type EntityType =
  | 'intake'
  | 'matter'
  | 'firm'
  | 'coverage'
  | 'carrier'
  | 'police_department'
  | 'provider_contact'
  | 'police_report';

interface SearchResultMetadata {
  [key: string]: string | number | boolean | null | undefined;
}

export interface SearchResult {
  entity_type: EntityType;
  entity_id: string;
  label: string;
  metadata: SearchResultMetadata;
}

interface TypeaheadSearchRequest {
  query: string;
  entity_types?: EntityType[];
  limit?: number;
}

interface TypeaheadSearchResponse {
  results: SearchResult[];
}

// Add query tracking to responses
interface TypeaheadSearchResponseWithQuery extends TypeaheadSearchResponse {
  _query: string; // Track which query these results are for
}

export const searchApi = createApi({
  reducerPath: 'searchApi',
  baseQuery: baseQueryWithErrorHandling,
  endpoints: (builder) => ({
    typeaheadSearch: builder.query<TypeaheadSearchResponseWithQuery, string>({
      query: (searchQuery) => {
        console.log('[SearchAPI] Sending query:', searchQuery);
        return {
          url: 'api/search/typeahead/',
          method: 'POST',
          body: {
            query: searchQuery,
            limit: 10,
          } as TypeaheadSearchRequest,
        };
      },
      transformResponse: (
        response: TypeaheadSearchResponse,
        meta,
        arg,
      ): TypeaheadSearchResponseWithQuery => {
        console.log('[SearchAPI] Received response for query:', arg, {
          resultCount: response.results.length,
          results: response.results.map((r) => r.label),
        });
        // Tag response with the query it corresponds to
        return {
          ...response,
          _query: arg,
        };
      },
      // Don't cache search results - always fetch fresh
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useTypeaheadSearchQuery } = searchApi;
